const data = {
  en: {
    text: "Hello World!",
  },
  de: {
    text: "Hallo Welt!",
  },
};

export { data };
